export type Visibility = 'not-visible' | 'visible' | 'scheduled';
export type DeadlineType = 'no-deadline' | 'deadline';

// Visibility radio button values
export const visibility = Object.freeze({
    notVisible: 'not-visible',
    visible: 'visible',
    scheduled: 'scheduled'
});

export const deadlineType = Object.freeze({
    noDeadline: 'no-deadline',
    withDeadline: 'deadline'
});

export const participantsPaginationPageSizes: readonly number[] = Object.freeze([100, 200]);

export const defaultDeadlineTime = "23:59";
export const defaultActiveFromTime = "8:00";
export const defaultActiveToTime = "16:00";